window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    revokeBtn: "<div class='cc-revoke'></div>",
    type: "opt-in",
    position: "bottom-right",
    palette: {
      popup: {
        background: "#fff",
      },
      button: {
        background: "#57B274",
      },
    },
    content: {
      message: "Wir verwenden Cookies, um unsere Webseite für Sie möglichst benutzerfreundlich zu gestalten.",
      link: "Weitere Informationen",
      allow: "Cookies erlauben",
      deny: "Ablehnen",
      href: "/datenschutz/",
    },
    onInitialise: function (status) {
      if (status == cookieconsent.status.allow) myScripts();
    },
    onStatusChange: function (status) {
      if (this.hasConsented()) myScripts();
    },
  });
});

function myScripts() {
  const script = document.createElement("script");

  script.src = "https://www.googletagmanager.com/gtag/js?id=G-SP5DL3X1L7";
  script.async = true;
  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-SP5DL3X1L7");
  };
  document.body.appendChild(script);
}
